import { OrderData } from 'support/helpers/orderForms/orderForms';

export const shouldPayTaxes = (parties: OrderData['parties']): boolean => {
  const billingCountry = parties?.bill_to?.country_code;
  const supplierCountry = parties?.supplier?.country_code;

  if (!billingCountry || !supplierCountry) {
    return false;
  }

  return billingCountry === supplierCountry;
};
